import { render } from "./loanapply.vue?vue&type=template&id=67ff7192&scoped=true"
import script from "./loanapply.vue?vue&type=script&lang=js"
export * from "./loanapply.vue?vue&type=script&lang=js"

import "./loanapply.vue?vue&type=style&index=0&id=67ff7192&scoped=true&lang=css"

import exportComponent from "D:\\Kaung\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ff7192"]])

export default __exports__